import { SidebarItem } from "./types"

/**
 * Filters sidebar items based on available module paths
 * @param items The original sidebar items data
 * @param availablePaths Array of available paths/hrefs to filter by
 * @returns Filtered sidebar items containing only items with matching hrefs
 */
export const filterSidebarData = (
  items: SidebarItem[],
  availablePaths: string[] = []
): SidebarItem[] => {
  if (!availablePaths || availablePaths.length === 0) {
    return []
  }

  // Filter items to only include those with matching hrefs
  return items.filter((item) => {
    if (item.href === "/legal") {
      return true
    }
    return (
      item.href &&
      availablePaths.some(
        (path) => item.href.toLowerCase() === path.toLowerCase()
      )
    )
  })
}

export default filterSidebarData
